module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "edit-delivery-address"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("orders.deliveryAddress.TitleModify")))]), _vm._v(" "), _c('div', {
    staticClass: "edit-delivery-address-textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.updateContentAddress),
      expression: "updateContentAddress",
      modifiers: {
        "trim": true
      }
    }],
    key: _vm.action.data.id,
    class: {
      empty: _vm.error
    },
    attrs: {
      "rows": "7",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.updateContentAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.updateContentAddress = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-client",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-client",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deliveryAdressModify();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.confirm")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e8fa078","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/actions/EditDeliveryAddress.vue
// module id = 3065
// module chunks = 0